import React from "react";
import { Routes, Route } from "react-router-dom";

import Layout from "./layout";
import Course from "./scenes/course";
import Learn from "./scenes/learn";
import Stats from "./scenes/stats";
import Editor from "./scenes/editor";
import Rating from "./scenes/rating";
import Library from "./scenes/library";
import CareerPath from "./scenes/career-path";
import Home from "./scenes/home";
import Resources from "./scenes/resources";
import Tracker from "./scenes/tracker";
import TraineeTest from "./scenes/tracker/trainee-test";

export default function SelecoleApp() {
  return (
    <Routes>
      {/* Standalone route for trainees - no layout/navigation */}
      <Route path="/training-test/:id" element={<TraineeTest />} />
      
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/course/*" element={<Course />} />
        <Route path="/learn/*" element={<Learn />} />
        <Route path="/stats/*" element={<Stats />} />
        <Route path="/editor/*" element={<Editor />} />
        <Route path="/rating/*" element={<Rating />} />
        <Route path="/tracker/*" element={<Tracker />} />
        <Route path="/library/*" element={<Library />} />
        <Route path="/resources/*" element={<Resources />} />
        <Route path="/rating" element={<Rating />} />
        <Route path="/career-path/*" element={<CareerPath />} />
      </Route>
    </Routes>
  );
}
